export default __webpack_public_path__ + "static/media/homepage.3e710fe4.jpg";